import { cva } from 'class-variance-authority';

const TEXT_XS_BASE = 'text-xs leading-4';
const TEXT_SM_BASE = 'text-sm leading-4';
const TEXT_MD_BASE = 'leading-5';
const TEXT_LG_BASE = 'text-lg leading-5';
const TEXT_XL_BASE = 'text-2xl leading-7';

const POPPINS_MEDIUM = 'font-["Poppins"] font-medium';

export const textStyles = cva('font-["Inter"] text-base font-normal text-denim-900', {
  variants: {
    variant: {
      'text-xs-light': `${TEXT_XS_BASE} font-light`,
      'text-xs-regular': TEXT_XS_BASE,
      'text-xs-medium': `${TEXT_XS_BASE} font-medium`,
      'text-xs-semibold': `${TEXT_XS_BASE} font-semibold`,
      'text-sm-light': `${TEXT_SM_BASE} font-light`,
      'text-sm-regular': TEXT_SM_BASE,
      'text-sm-medium': `${TEXT_SM_BASE} font-medium`,
      'text-sm-semibold': `${TEXT_SM_BASE} font-semibold`,
      'text-md-regular': TEXT_MD_BASE,
      'text-md-medium': `${TEXT_MD_BASE} font-medium`,
      'text-md-semibold': `${TEXT_MD_BASE} font-semibold`,
      'text-lg-regular': TEXT_LG_BASE,
      'text-lg-medium': `${TEXT_LG_BASE} font-medium`,
      'text-xl-regular': TEXT_XL_BASE,
      'text-xl-medium': `${TEXT_XL_BASE} font-medium`,
      'heading-2xs-medium': `${POPPINS_MEDIUM} text-xs leading-4`,
      'heading-xs-medium': `${POPPINS_MEDIUM} text-sm leading-4`,
      'heading-sm-medium': `${POPPINS_MEDIUM} leading-5`,
      'heading-md-medium': `${POPPINS_MEDIUM} text-lg leading-5`,
      'heading-lg-medium': `${POPPINS_MEDIUM} text-xl leading-6`,
      'heading-xl-medium': `${POPPINS_MEDIUM} text-2xl leading-7`,
      'heading-2xl-medium': `${POPPINS_MEDIUM} text-4xl leading-9`,
      'heading-3xl-medium': `${POPPINS_MEDIUM} text-5xl leading-13`,
    },
  },
  defaultVariants: {
    variant: 'text-md-regular',
  },
});
